<template>
<div id="app">
    <router-view/>
</div>
</template>

<script>
export default {
    name: 'app',
    data() {
        return {
        };
    },
    components: {
      
    }
}
</script>

<style>
#app {}
.viewer-play, .viewer-reset {
  display: none;
}
</style>
